import type { NormalizedLandmark } from '@mediapipe/tasks-vision';
import {
  WIRE_LANDMARK_INDICES,
  type WireLandmark,
} from '../protocol.ts';

/** The only body points permitted to leave CAMERA: shoulders, hips and ankles. */
export function toWireLandmarks(landmarks: readonly NormalizedLandmark[]): WireLandmark[] | undefined {
  const selected: WireLandmark[] = [];
  for (const index of WIRE_LANDMARK_INDICES) {
    const landmark = landmarks[index];
    if (!landmark
      || !Number.isFinite(landmark.x)
      || !Number.isFinite(landmark.y)
      || !Number.isFinite(landmark.z)) return undefined;
    const wire: WireLandmark = {
      index,
      x: landmark.x,
      y: landmark.y,
      z: landmark.z,
    };
    if (Number.isFinite(landmark.visibility)) wire.visibility = landmark.visibility;
    selected.push(wire);
  }
  return selected;
}
